






































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import Loading from '@/app/components/Common/Loading.vue'
/* api */
import LoginApi from '@/app/model/api/loginApi'
/* module */
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorInfo
  }
})
export default class Login extends Vue {
  private email: string = ''
  private password: string = ''
  private errorMessages: any = ''
  private alertText: string = ''
  private showLoading: boolean = false
  private showAlert: boolean = false
  private show400ErrorMessage: boolean = false

  private async login () {
    /* ログイン処理が成功したらfieldへ遷移、失敗したらアラートを表示 */
    if (this.isLogin()) {
      const bodyData = {
        'mailaddress': this.email,
        'password': this.password
      }
      this.showLoading = true

      const result = await LoginApi.doLogin(bodyData)
      if (result.isOk()) {
        // サービス機能設定値を再取得しローカルストレージにセット
        await CommonClass.setServiceFunctionData('pc')
        this.$router.push(routerPath.PATH_FIELD).catch(e => {})
      } else if (result.getPayload().status_code === '404' ||
                 result.getPayload().status_code === '400') {
        this.alertText = 'メールアドレスまたはパスワードが違うため、ログインできませんでした。'
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      } else {
        // 500系もしくはbodyがない場合と、その他
        this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
        this.$router.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
      }
    } else {
      this.alertText = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
    this.showLoading = false
  }

  private isLogin () {
    const emailFlag = Validator.validateInputEmail('emailErrorMessage', this.email)
    const passwordFlag = Validator.validateInputPassword('passwordErrorMessage', this.password)

    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    return emailFlag && passwordFlag
  }
}
